import { render, staticRenderFns } from "./RTFooter.vue?vue&type=template&id=83fa076e&"
import script from "./RTFooter.vue?vue&type=script&lang=js&"
export * from "./RTFooter.vue?vue&type=script&lang=js&"
import style0 from "./RTFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports